import React from 'react'
let selected = '';
let vector_2 = [1];

const Info = function info ({user,address,cities,onChange,onSubmit,onChangeCity,form,click,addressList}){
    return (
        <main>
            <div className="back flex w90">
                <a href={https} className="flex">
                    <img src={https+"img/back.svg"} alt="⬅"/>
                    <span>Atrás</span>
                </a>
                </div>
            
                <div className="titMobProfile flex">
                <h3>Perfil</h3>
            </div>
            <section className="profile profile_go">
                <div className="container w90 colflex">
                
                    <div className="sec1 dnone">
                        <h3>Perfil de usuario</h3>
                        <img src={https+"img/userLog.svg"} alt="user-icon"/>
                        <p>Usuario</p>
                        <span>{nameUser}</span>
                        <a href={https+"update"}>Actualizar Datos</a>
                        <a className='a_2' href={https+"orders"}>Ver compras</a>
                        <a href={https+'api/logout'}>Salir</a>
                    </div>
                
                    <div className="colflex sepSecs">
                        <div className="sec2">
                            <h3 className="dnone">
                                Edita tus datos personales
                            </h3>
                            <form id="formUpdate" className="container grid w90" action="" onSubmit={onSubmit}>
                                <div className="colflex">
                                    <label for="">Nombre</label>
                                    <input
                                        readOnly
                                        type="text"
                                        name="name"
                                        value={form.name}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="colflex">
                                    <label for="">Apellidos</label>
                                    <input
                                        readOnly
                                        type="text"
                                        name="lastname"
                                        value={form.lastname}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="colflex">
                                    <label for="">Cedula de ciudadanía</label>
                                    <input 
                                        readOnly
                                        type="text" 
                                        name="identy"
                                        value={form.identy}
                                        onChange={onChange}    
                                    />
                                </div>
                                <div className="colflex">
                                    <label for="">Email</label>
                                    <input
                                        readOnly
                                        type="text"
                                        name="mail"
                                        value={form.mail}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="colflex">
                                    <label for="">Teléfono</label>
                                    <input
                                        readOnly
                                        type="text"
                                        name="phone"
                                        value={form.phone}
                                        onChange={onChange}
                                    />
                                </div>
                            </form>
                            
                            <div className="subTotal colflex">
                            {vector_2.map((v) => {
                                if(addressList.length > 0){
                                    return (
                                        <div className="flex address">
                                            <p style={{
                                                textAlign: 'left',
                                                width: '100%'
                                                }}>
                                                Lista de Direcciónes
                                            </p>
                                        </div>
                                    )
                                }
                            })}
                            {addressList.map((a)=>{
                                return (
                                    <div className="flex address">
                                        <p>
                                            <label 
                                                onClick={() => changeAddress(a.id)}
                                                for={"address_" + a.id}
                                            >
                                                {a.address}
                                            </label>
                                        </p>
                                    </div>
                                )
                            }
                            )}
                            </div>
                        </div>
                        

                    
                        <hr className="w90"/>
                    
                        <div className="sec3 flex w90">
                            <div className="colflex">
                                <label for="">Contraseña</label>
                                <input
                                    readOnly
                                    type="password" 
                                    name="password"
                                    value="****************"    
                                />
                            </div>
                        </div>

                    </div>
                
                </div>
                
                <div className="btnSessions w80 colflex">
                    <a href={https+"orders"} className="btnOrders">Ver compras</a>
                    <a href={https+'api/logout'} className="btnLogOut">Salir</a>
                </div>
            </section>
        </main>
    )
}

export default Info
